/* import __COLOCATED_TEMPLATE__ from './o-classes-creator.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class OClassesCreatorComponent extends Component 
{
	@service store;
	
	ageClasses = [21,35,40,45,50,55,60,65,70,75,80,85];
	genders = [{display:"M",internal:"M"},{display:"W",internal:"F"}];
	
	@action createClasses()
	{
		var that = this;
		this.currentGender = this.genders[0];
		return this.sequentialArrayPromise(0,this.ageClasses,this.createClassAndClassGroup,this).then(function()
		{
			that.currentGender = that.genders[1]
			return that.sequentialArrayPromise(0,that.ageClasses,that.createClassAndClassGroup,that);
		});
	}
	
	sequentialArrayPromise(currentIndex,array,promiseFn,context)
	{
		var that = this;
		return promiseFn(array[currentIndex],context).then(function()
		{
			if(currentIndex < (array.length-1))
			{
				return that.sequentialArrayPromise(currentIndex+1,array,promiseFn,context);
			}
			else
				return;
		});
	}
	
	createClassAndClassGroup(ageClass,context)
	{
		var gender = context.currentGender;
		var store = context.store;
		var event = context.args.event;
		
		var newClassGroup = store.createRecord('class-group',
		{
			name: gender.display+ageClass,
			EventId: event,
		});
		return newClassGroup.save().then(function(savedClassGroup)
		{
			var newClass = store.createRecord('class',
			{
				name: gender.display+ageClass,
				gender: gender.internal,
				EventId: event,
				ClassGroupId:savedClassGroup
			});
			return newClass.save();
		});
	}
}

